module.exports = __webpack_public_path__ + "static/media/linkedIcon.eeb222fc.PNG";